<template>
	<div class="Bar">
		<div v-for="(item , index) of echartsOptions" :key="index">
			<div :id="'EchartsBar'+item.numCharts" style="height: 400px;"></div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			echartsOptions: {
				type: Array,
				default: () => {
					return []
				}
			},
			num: {
				type: Number,
				default: 1
			},
			StockCost: {
				type: Object,
				default: () => {
					return {

					}
				}
			}
		},
		data() {
			return {
				numCharts: this.num,
				pieData: {}
			}
		},
		created() {},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			BarInit() {
				this.echartsOptions.forEach((item, index) => {
					var myChart = this.$MyEcharts.init(document.getElementById("EchartsBar" + item.numCharts),
						'shine');
					var option = {
						tooltip: item.tooltip,
						visualMap: item.visualMap,
						emphasis: item.emphasis,
						legend: item.legend,
						toolbox: item.toolbox,
						series: item.series
					};
					myChart.setOption(option, true);
				})
			},

		},
		computed: {},
		watch: {
			StockCost: {
				handler(NewVal, OldVal) {
					if (NewVal) {
						this.echartsOptions[0].series[0].data = []
						if (NewVal.type == 'L2data') {
							NewVal.L2Amount.forEach((item, index) => {
								let PieSeries = {
									value: item.Quantity || item.Sum,
									name: item.Name || item.LEVEL2,
									itemStyle: {
										// color: "#9A0A21",
									},
									label: {
										//{d}显示百分比。｛a|｝富文本样式标签。｛b｝数据: "{b}\n{a|{d}%}",
										formatter: "{b}\n{a|{d}%}",
										rich: {
											a: {
												// color: "#9A0A21",
											},
										},
									}
								}
								this.echartsOptions[0].series[0].data.push(PieSeries)
							})
						} else {
							NewVal.data.forEach((item, index) => {
								let PieSeries = {
									value: item.Quantity,
									name: item.Name,
									itemStyle: {
										// color: "#9A0A21",
									},
									label: {
										//{d}显示百分比。｛a|｝富文本样式标签。｛b｝数据: "{b}\n{a|{d}%}",
										formatter: "{b}\n{a|{d}%}",
										rich: {
											a: {
												// color: "#9A0A21",
											},
										},
									}
								}
								this.echartsOptions[0].series[0].data.push(PieSeries)
							})
						}
						window.setTimeout(() => {
							this.BarInit();
						}, 1000)

						// // 实例化echarts对象
						// this.$nextTick(() => {

						// })
					}
				},
				deep: true,
				immediate: true
			}
		},
	}
</script>
<style scoped lang='less'>
</style>
